export default {
  FLEX: 'FLEX',
  PROJECT_SUBMISSION: 'PROJECT_SUBMISSION',
  PROJECT_COMPLETED: 'PROJECT_COMPLETED'
};
